import Grid from "@material-ui/core/Grid";
import { ViewStyled, TextStyled, ViewRow } from "./Graphic";
import Card from './Card.component';

interface GraphicInterface {
  title: string;
  qttAssessments: number ;
  answeredReviews: number;
  nps: number|string;
}

export default function Rankings({ title, qttAssessments, answeredReviews, nps }: GraphicInterface) {


  return (
    <Grid item xs={12} sm={6}>
      <ViewStyled>
        <TextStyled>
          {title}
        </TextStyled>
        {/* <Card title='Cencosud' ranking={3} /> */}
        <ViewRow>
          <Card title='Quantidade de Avaliações' ranking={qttAssessments} />
          <Card title='Avaliações respondidas' ranking={answeredReviews} />
          <Card title='NPS do mês' ranking={nps} />
        </ViewRow>

      </ViewStyled>
    </Grid>
  );
}
